module.exports = __webpack_public_path__ + "static/media/depoimento-elisabete.66932ad4.jpeg";